//Container

<template>
  <div>
    <component v-bind:is="currentComponent"></component>
  </div>
</template>
<script>
import listarPacientes from "../components/pacientes/ListaPacientes.vue";
import novoPaciente from "../components/pacientes/NovoPaciente.vue";
import perfilPaciente from "../components/pacientes/PerfilPaciente.vue";

export default {
  components: {
    listarPacientes,
    novoPaciente,
    perfilPaciente,
  },

  data() {
    return {
      currentComponent: "",
    };
  },
  mounted() {
    this.currentComponent =
      this.$route.query.type === "a"
        ? novoPaciente
        : this.$route.query.type === "b"
        ? perfilPaciente
        : listarPacientes;
  },
  watch: {
    $route(to, from) {
      this.currentComponent =
        to.query.type === "a"
          ? "novoPaciente"
          : to.query.type === "b"
          ? "perfilPaciente"
          : "listarPacientes";
    },
  },
};
</script>
